import React, { Component } from 'react';
import moment from 'moment';
import _ from 'lodash';
import 'moment/locale/es';

export default class RechazadoEntregas extends Component {

  constructor(props) {
    super(props);
    this.state = {
      display: 'none',
    };
    this.cerrarModalVerRechazo = this.cerrarModalVerRechazo.bind(this);
  }
  cerrarModalVerRechazo() {
    this.props.cerrarModalVerRechazo();
  }
  renderInformacion() {
    return (
      <div>
        <header className='fdv-section-head'>
          <h5 className='fdv-section-title'>Información de rechazo</h5>
        </header>
        <div className='card card-lg card-plain mb-3'>
          <div className='row'>
            
            <div className='col-md-4'>
              <label className='labelInfo'>Motivo de rechazo</label>
              <p>{this.props.entregasLogistica.motiRech}</p>
            </div>
            <div className='col-md-4'>
              <label className='labelInfo'>Fecha de entrega propuesta
                  </label>
              <p><i className='ion-calendar' /> { this.props.entregasLogistica.fecPropRepr? moment(this.props.entregasLogistica.fecPropRepr).format('DD/MM/YYYY HH:mm') : '-'}</p>
            </div>
          </div>
          <div className='row'>
            <div className='col-md-12'>
              <label className='labelInfo'>Comentario</label>
              <p>{this.props.entregasLogistica.obsMotiRech}</p>
            </div>
          </div>
        </div>
      </div>
    );
  }
  render() {
    return !this.props.entregasLogistica ? null : (
      <div>
        <div className='modal' id='entrega-detalle' role='dialog' data-backdrop='static' style={{ display: this.props.muestraModalVerRechazo }} >
          <div className='modal-dialog modal-lg modal-noTitle' role='document'>
            <button className='btn btn-sm btn-blue modal-close' data-dismiss='modal' onClick={this.cerrarModalVerRechazo} >Cerrar ventana</button>
            <div className='modal-content'>
              <div className='modal-body'>
                <div className='modalBleed modalBleed-top'>
                  <div className='carCard'>
                    <div className='carCard-firstInfo'>
                      <p className='tag tag-Top tag-green'>{_.capitalize(this.props.tipoProg)}</p>
                      <div className='text-right'>
                        <div className='dropdown kebab' role='group' />
                      </div>
                      <div className='row'>
                        <div className='col-md-5'>
                        <h2 className='h4 mt-0'><span className='bold'>{this.props.entregasLogistica.nomMarca}</span><br /><span>{this.props.entregasLogistica.modelo}</span></h2>
                        </div>
                        <div className='col-md-2'>
                          <p className='labelInfo'>Nº FDV</p>
                          <p>{this.props.entregasLogistica.numFichaVta}</p>
                        </div>
                        <div className='col-md-3'>
                          <p className='labelInfo'>Nº Chasis</p>
                          <p>{this.props.entregasLogistica.numChasis}</p>
                        </div>
                        <div className='col-md-2'>
                          <p className='labelInfo'>Nº Pedido</p>
                          <p>{this.props.entregasLogistica.numPedidoVeh}</p>
                        </div>
                      </div>
                      <div className='row'>
                        <div className='col-md-4'>
                          <p className='labelInfo' style={{fontSize:'0.9em',fontWeight:'800'}}>Propietario</p>
                          <p>{this.props.entregasLogistica.desCliente}</p>
                        </div>
                        <div className='col-md-4'>
                          <p className='labelInfo' style={{fontSize:'0.9em',fontWeight:'800'}}>{this.props.entregasLogistica.dni === '' || this.props.entregasLogistica.dni === null ? 'RUC' : 'DNI'} </p>
                          <p>{this.props.entregasLogistica.dni === '' || this.props.entregasLogistica.dni === null ? `${this.props.entregasLogistica.ruc}` : `${this.props.entregasLogistica.dni}`}</p>
                        </div>
                        <div className='col-md-4'>
                          <p className='labelInfo' style={{fontSize:'0.9em',fontWeight:'800'}}>Asesor Comercial </p>
                          <p>{this.props.entregasLogistica.asesorComercial}</p>
                        </div>
                      </div>
                    </div>
                    <div className='carCard-sec'>
                      <div className='row'>
                        <div className='col-sm-4'>
                          <p className='labelInfo'>Área de venta</p>
                          <p>{this.props.entregasLogistica.desAreaVta}</p>
                        </div>
                        <div className='col-sm-2'>
                          <p className='labelInfo'>Familia</p>
                          <p>{this.props.entregasLogistica.desFamiliaVeh}</p>
                        </div>
                        <div className='col-sm-2'>
                          <p className='labelInfo'>Fª C. Comer.</p>
                          <p>{this.props.entregasLogistica.fechaCompEntrega ? moment(this.props.entregasLogistica.fechaCompEntrega).format('DD/MM/YYYY') : '-'}</p>
                        </div>
                        <div className='col-sm-2'>
                          <p className='labelInfo'>Fª C. Logíst.</p>
                          <p>{this.props.entregasLogistica.fechaComLog ? moment(this.props.entregasLogistica.fechaComLog).format('DD/MM/YYYY') : '-'}</p>
                        </div>
                        <div className='col-sm-2'>
                          <p className='labelInfo'>Fª Ent. Placa</p>
                          <p>{this.props.entregasLogistica.fecRecepPlaca ? moment(this.props.entregasLogistica.fecRecepPlaca).format('DD/MM/YYYY') : '-'}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='tabs-hr'>
                    <ul className='tabs' role='tablist'>
                      <li role='presentation' className={`tabs-item active`} >
                        <a className='tabs-item-link'  role='tab' aria-controls='infoEntrega' data-toggle='tab'>Información de rechazo</a>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className='tab-content'>
                  <section className={`tab-pane active`} id='infoEntrega'>
                    {this.renderInformacion()}
                  </section>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FichaEntrega/RechazadoEntregas.js